// extracted by mini-css-extract-plugin
export default {"other":"index_other_Bqay-","judgesImg":"index_judgesImg_X1i1g"};